import Hero from "../components/sections/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import AudioDemo from "../components/sections/AudioDemo";
import Manifesto from "../components/sections/Manifesto";
import RoiCalculator from "../components/sections/RoiCalculator";
import LeadCapture from "../components/sections/LeadCapture";
import TelegramCta from "../components/sections/TelegramCta";

const Home = () => (
  <main data-testid="home-page">
    <Hero />
    <EditorialMarquee />
    <AudioDemo />
    <Manifesto />
    <RoiCalculator />
    <LeadCapture />
    <TelegramCta />
  </main>
);

export default Home;
